import { Suspense, lazy, type FunctionComponent } from "preact/compat";

import MODULE_LIST from "./views.js";

const COMPONENT_MAP = Object.fromEntries(
  MODULE_LIST.map(({ path, module }) => {
    const name = path.slice(6, -3);
    return [
      name,
      lazy(module as () => Promise<{ default: FunctionComponent }>),
    ];
  })
);

function Null() {
  return null;
}

type ComponentLoaderProps = {
  componentName?: string;
  props: Record<string, any>;
};

export function ComponentLoader({
  componentName,
  props,
}: ComponentLoaderProps) {
  if (componentName === undefined) {
    throw new Error("No component name specified");
  }
  const Component = COMPONENT_MAP[componentName];
  if (Component === undefined) {
    throw new Error(`Unknown component name "${componentName}"`);
  }
  return (
    <Suspense fallback={<Null />}>
      <Component {...(props as any)} />
    </Suspense>
  );
}
